<template>
    <div>
        <div class="modal fade modern-modal " id="ModalImportacaoPCA" ref="modalImportacaoPCA" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-xl modal-grande">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            data-bs-dismiss="modal" aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Importar do PCA / PNCP</h2>
                            <p>Pesquise pelo CNPJ da instituição e ano para criar o Registro de Necessidade.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="pca-layout">
                            <div v-if="carregandoBuscaInicial" class="pca-loading-banner" role="status">
                                <span class="pca-loading-spin" aria-hidden="true" />
                                <span>{{ mensagemCarregamento }}</span>
                            </div>

                            <!-- 1. Busca -->
                            <div class="pca-card pca-card-filter">
                                <div class="pca-filter-row">
                                    <div class="pca-field pca-field-grow">
                                        <label class="pca-label">CNPJ do Órgão</label>
                                        <div class="pca-input-with-icon">
                                            <input :value="cnpjOrgao"
                                                   type="text"
                                                   class="pca-input"
                                                   placeholder="AA.AAA.AAA/AAAA-00"
                                                   maxlength="18"
                                                   autocomplete="off"
                                                   @input="onCnpjInput" />
                                            <span class="pca-input-suffix" aria-hidden="true">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                                    <path d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-4M9 9v0M9 12v0M9 15v0M9 18v0" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="pca-field pca-field-ano">
                                        <label class="pca-label">Ano</label>
                                        <input v-model="anoPca"
                                               type="text"
                                               class="pca-input"
                                               maxlength="4"
                                               placeholder="AAAA"
                                               autocomplete="off" />
                                    </div>
                                    <div class="pca-field pca-field-btn">
                                        <label class="pca-label pca-label-invisible">Ação</label>
                                        <button type="button"
                                                class="pca-btn-consultar"
                                                :disabled="carregando || !cnpjConsultaValido"
                                                @click="consultar">
                                            <svg v-if="!carregandoBuscaInicial"
                                                 xmlns="http://www.w3.org/2000/svg"
                                                 width="18"
                                                 height="18"
                                                 viewBox="0 0 24 24"
                                                 fill="none"
                                                 stroke="currentColor"
                                                 stroke-width="2">
                                                <circle cx="11" cy="11" r="8" />
                                                <path d="m21 21-4.35-4.35" stroke-linecap="round" />
                                            </svg>
                                            <span v-else class="pca-btn-spinner" aria-hidden="true" />
                                            <span>{{ carregandoBuscaInicial ? 'Consultando...' : 'Consultar' }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- 2. Seleção de PCA (acima dos dados da instituição) -->
                            <div v-if="listaPca.length > 0" class="pca-card pca-card-pca-list">
                                <div class="pca-pca-list-head">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" class="pca-doc-icon">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke-linejoin="round" />
                                        <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke-linecap="round" />
                                    </svg>
                                    <p class="pca-pca-list-text">
                                        Este órgão possui <strong>{{ listaPca.length }}</strong> PCA(s).
                                        Marque os que deseja <strong>importar</strong> e clique no botão do PCA para <strong>visualizar</strong> os itens.
                                    </p>
                                    <button type="button"
                                            class="pca-btn-csv pca-btn-selecionar-todos-pca"
                                            :disabled="carregando || importando || todosPcasMarcadosParaImportacao"
                                            :title="'Marcar os ' + listaPca.length + ' PCA(s) para importação'"
                                            @click="selecionarTodosPcasParaImportacao">
                                        Selecionar todos para importação
                                    </button>
                                </div>
                                <div class="pca-pca-chips">
                                    <div v-for="n in listaPca"
                                         :key="'pca-' + n"
                                         class="pca-chip-wrap">
                                        <label class="pca-chip-import"
                                               :title="'Incluir PCA #' + n + ' na importação'"
                                               @click.stop>
                                            <input type="checkbox"
                                                   :checked="isPcaMarcadoParaImport(n)"
                                                   :disabled="carregando || importando"
                                                   @change="setMarcaImportPca(n, $event.target.checked)">
                                        </label>
                                        <button type="button"
                                                class="pca-chip"
                                                :class="{ active: pcaPrevisualizado === n }"
                                                :disabled="carregando || importando"
                                                @click="previsualizarPca(n)">
                                            PCA #{{ n }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- 3. Resumo do órgão / PCA -->
                            <div v-if="resumoOrgao" class="pca-card pca-card-resumo">
                                <div class="pca-resumo-banner">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" class="pca-banner-icon">
                                        <path d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-4M9 9v0M9 12v0M9 15v0M9 18v0" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <div class="pca-banner-text">
                                        <div class="pca-banner-title">{{ resumoOrgao.nome }}</div>
                                        <div class="pca-banner-sub">CNPJ: {{ resumoOrgao.cnpj }}</div>
                                    </div>
                                </div>
                                <div class="pca-metricas">
                                    <div class="pca-metrica">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="pca-metrica-ico">
                                            <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z" />
                                            <circle cx="12" cy="10" r="3" />
                                        </svg>
                                        <span class="pca-metrica-label">Localização</span>
                                        <span class="pca-metrica-valor">{{ resumoOrgao.localizacao }}</span>
                                    </div>
                                    <div class="pca-metrica">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="pca-metrica-ico">
                                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                            <path d="M16 2v4M8 2v4M3 10h18" />
                                        </svg>
                                        <span class="pca-metrica-label">Ano PCA</span>
                                        <span class="pca-metrica-valor">{{ resumoOrgao.anoPca }}</span>
                                    </div>
                                    <div class="pca-metrica">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="pca-metrica-ico">
                                            <path d="M4 9h16M4 15h7M4 12h7" stroke-linecap="round" />
                                        </svg>
                                        <span class="pca-metrica-label">Nº Controle</span>
                                        <span class="pca-metrica-valor pca-metrica-valor-sm">{{ resumoOrgao.numeroControle }}</span>
                                    </div>
                                    <div class="pca-metrica">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="pca-metrica-ico">
                                            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                                        </svg>
                                        <span class="pca-metrica-label">Total de Itens</span>
                                        <span class="pca-metrica-valor">{{ resumoOrgao.totalItens }}</span>
                                    </div>
                                    <div class="pca-metrica">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="pca-metrica-ico">
                                            <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke-linecap="round" />
                                        </svg>
                                        <span class="pca-metrica-label">Valor Total</span>
                                        <span class="pca-metrica-valor pca-valor-total">{{ resumoOrgao.valorTotal }}</span>
                                    </div>
                                </div>
                                <div class="pca-resumo-footer">
                                    {{ resumoOrgao.metaLinha }}
                                </div>
                            </div>

                            <!-- 4. Tabela de itens (mensagem de carregamento do PCA/itens fica aqui) -->
                            <div v-if="itens.length || carregandoDetalhesPca" class="pca-card pca-card-tabela">
                                <div v-if="carregandoDetalhesPca" class="pca-table-loading" role="status">
                                    <span class="pca-loading-spin" aria-hidden="true" />
                                    <span>{{ mensagemCarregamento }}</span>
                                </div>
                                <template v-else>
                                    <div class="pca-toolbar">
                                        <div class="pca-toolbar-search">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <circle cx="11" cy="11" r="8" />
                                                <path d="m21 21-4.35-4.35" stroke-linecap="round" />
                                            </svg>
                                            <input v-model="filtroItens"
                                                   type="search"
                                                   class="pca-toolbar-input"
                                                   placeholder="Filtrar itens..." />
                                        </div>
                                        <div class="pca-toolbar-right">
                                            <span class="pca-toolbar-count">{{ itensFiltrados.length }} de {{ itens.length }} itens</span>
                                            <button type="button" class="pca-btn-csv" @click="exportarCsv">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                CSV
                                            </button>
                                        </div>
                                    </div>
                                    <div class="pca-table-wrap">
                                        <table class="pca-table">
                                        <thead>
                                            <tr>
                                                <th class="pca-th-sort" @click="alternarOrdenacao('numero')">
                                                    Nº
                                                    <span class="pca-sort" :class="{ active: sortKey === 'numero' }">⇅</span>
                                                </th>
                                                <th class="pca-th-sort" @click="alternarOrdenacao('descricao')">
                                                    Descrição
                                                    <span class="pca-sort" :class="{ active: sortKey === 'descricao' }">⇅</span>
                                                </th>
                                                <th class="pca-th-sort" @click="alternarOrdenacao('categoria')">
                                                    Categoria
                                                    <span class="pca-sort" :class="{ active: sortKey === 'categoria' }">⇅</span>
                                                </th>
                                                <th>Classificação</th>
                                                <th>Grupo Contratação</th>
                                                <th class="pca-th-sort pca-th-num" @click="alternarOrdenacao('quantidade')">
                                                    Qtd
                                                    <span class="pca-sort" :class="{ active: sortKey === 'quantidade' }">⇅</span>
                                                </th>
                                                <th class="pca-th-num">Unid.</th>
                                                <th class="pca-th-num">Valor Unit.</th>
                                                <th class="pca-th-sort pca-th-num" @click="alternarOrdenacao('valorTotal')">
                                                    Valor Total
                                                    <span class="pca-sort" :class="{ active: sortKey === 'valorTotal' }">⇅</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="row in itensFiltradosOrdenados" :key="row.id">
                                                <td>{{ row.numero }}</td>
                                                <td class="pca-td-desc">
                                                    <div class="pca-desc-titulo">{{ row.descricao }}</div>
                                                    <div v-if="row.subtitulo" class="pca-desc-sub">{{ row.subtitulo }}</div>
                                                </td>
                                                <td>
                                                    <span class="pca-badge"
                                                          :class="row.categoriaItemPcaid === 1 ? 'pca-badge-material' : 'pca-badge-servico'">
                                                        {{ row.categoria }}
                                                    </span>
                                                </td>
                                                <td>{{ row.classificacao }}</td>
                                                <td>{{ row.grupoContratacao }}</td>
                                                <td class="pca-td-num">{{ formatNumberPt(row.quantidade) }}</td>
                                                <td class="pca-td-num">{{ row.unidade }}</td>
                                                <td class="pca-td-num">{{ formatMoney(row.valorUnitario) }}</td>
                                                <td class="pca-td-num">{{ formatMoney(row.valorTotal) }}</td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <div class="modal-modern-footer">
                        <button type="button"
                                class="modern-btn modern-btn-primary w-100"
                                :disabled="importando || !podeImportar"
                                @click="importarItensCgov">
                            <span v-if="!importando">Importar {{ textoBotaoImportar }}</span>
                            <span v-else>Importando...</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { urlApi, avisoToast, avisoErro } from '@/config/global'
    import axios from 'axios'

    const PNCP_PCA_BASE_URL = 'https://pncp.gov.br/api/pncp/v1';
    /** Pausa entre páginas de itens para reduzir 429 (rate limit do PNCP). */
    const PNCP_ITENS_INTERVALO_MS = 450;
    const PNCP_ITENS_MAX_TENTATIVAS_429 = 10;

    /** CNPJ alfanumérico sem máscara: 12 alfanuméricos + 2 dígitos verificadores. */
    function pncpCnpjRaw(cnpj) {
        const cleaned = String(cnpj || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        let base = '';
        let dv = '';
        let i;

        for (i = 0; i < cleaned.length && base.length < 12; i++) {
            base += cleaned.charAt(i);
        }

        for (; i < cleaned.length && dv.length < 2; i++) {
            if (/\d/.test(cleaned.charAt(i))) {
                dv += cleaned.charAt(i);
            }
        }

        return base + dv;
    }

    function formatCnpjAlfanumerico(value) {
        const cleaned = String(value || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        let base = '';
        let dv = '';
        let i;

        for (i = 0; i < cleaned.length && base.length < 12; i++) {
            base += cleaned.charAt(i);
        }

        for (; i < cleaned.length && dv.length < 2; i++) {
            if (/\d/.test(cleaned.charAt(i))) {
                dv += cleaned.charAt(i);
            }
        }

        let formatted = base.substring(0, 2);
        if (base.length > 2) formatted += '.' + base.substring(2, 5);
        if (base.length > 5) formatted += '.' + base.substring(5, 8);
        if (base.length > 8) formatted += '/' + base.substring(8, 12);
        if (dv.length > 0) formatted += '-' + dv;

        return formatted;
    }

    function getCnpjRawCharCount(value) {
        const cleaned = String(value || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        let count = 0;
        let base = 0;
        let i;

        for (i = 0; i < cleaned.length && base < 12; i++) {
            base++;
            count++;
        }

        for (; i < cleaned.length && count < 14; i++) {
            if (/\d/.test(cleaned.charAt(i))) {
                count++;
            }
        }

        return count;
    }

    function getCnpjCursorPosition(formatted, rawCharCount) {
        let count = 0;
        let i;

        for (i = 0; i < formatted.length; i++) {
            if (/[A-Z0-9]/.test(formatted.charAt(i))) {
                count++;
                if (count >= rawCharCount) {
                    return i + 1;
                }
            }
        }

        return formatted.length;
    }

    function pncpDelay(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    async function fetchPcaQuantidade(cnpj, ano) {
        const res = await fetch(`${PNCP_PCA_BASE_URL}/orgaos/${pncpCnpjRaw(cnpj)}/pca/${ano}/quantidade`);
        if (!res.ok) throw new Error(`Erro ao buscar quantidade de PCAs: ${res.status}`);
        const data = await res.json();
        return typeof data === 'number' ? data : data.quantidade ?? 0;
    }

    async function fetchPcaConsolidado(cnpj, ano, sequencial) {
        const res = await fetch(`${PNCP_PCA_BASE_URL}/orgaos/${pncpCnpjRaw(cnpj)}/pca/${ano}/${sequencial}/consolidado`);
        if (!res.ok) throw new Error(`Erro ao buscar consolidado do PCA: ${res.status}`);
        return res.json();
    }
     
    function normalizarListaItens(data) {
        if (Array.isArray(data)) {
            return data;
        }
        if (data && typeof data === 'object') {
            const chave = Object.keys(data).find((nome) => Array.isArray(data[nome]));
            if (chave) {
                return data[chave];
            }
        }
        return [];
    }

    /**
     * Uma página de itens, com retentativa em 429 e respeito a Retry-After.
     */
    async function fetchPcaItensPagina(cnpj, ano, sequencial, pagina, tamanhoPagina = 500) {
        const url = `${PNCP_PCA_BASE_URL}/orgaos/${pncpCnpjRaw(cnpj)}/pca/${ano}/${sequencial}/itens?pagina=${pagina}&tamanhoPagina=${tamanhoPagina}`;
        let tentativa429 = 0;
        for (;;) {
            const res = await fetch(url);
            if (res.ok) {
                return res.json();
            }
            if (res.status === 429 && tentativa429 < PNCP_ITENS_MAX_TENTATIVAS_429) {
                tentativa429 += 1;
                const ra = res.headers.get('Retry-After');
                let esperaMs = 1500 * 2 ** (tentativa429 - 1);
                if (ra) {
                    const segundos = parseInt(ra, 10);
                    if (!Number.isNaN(segundos) && segundos > 0) {
                        esperaMs = Math.max(esperaMs, segundos * 1000);
                    }
                }
                esperaMs = Math.min(esperaMs, 90000);
                await pncpDelay(esperaMs);
                continue;
            }
            throw new Error(`Erro ao buscar itens do PCA: ${res.status}`);
        }
    }

    async function fetchAllPcaItens(cnpj, ano, sequencial, totalItens) {
        let pageSize = 500;
        const esperado = Number(totalItens) || 0;
        const allItems = [];
        await pncpDelay(300);

        if (esperado <= 0) {
            const unicaPagina = normalizarListaItens(await fetchPcaItensPagina(cnpj, ano, sequencial, 1, pageSize));
            allItems.push(...unicaPagina);
            return allItems;
        }

        let page = 1;
        while (allItems.length < esperado) {
            if (page > 1) {
                await pncpDelay(PNCP_ITENS_INTERVALO_MS);
            }
            const items = normalizarListaItens(await fetchPcaItensPagina(cnpj, ano, sequencial, page, pageSize));
            if (items.length === 0) {
                break;
            }
            allItems.push(...items);
            if (items.length < pageSize && allItems.length < esperado) {
                pageSize = items.length;
            }
            page += 1;
            if (page > esperado + 2) {
                break;
            }
        }
        return allItems;
    }

    export default {
        name: 'ModalImportacaoPCA',
        data() {
            const anoAtual = new Date().getFullYear();
            return {
                retornoAoFechar: null,
                foiFechadaDeFormaTemporaria: false,
                importando: false,
                cnpjOrgao: '',
                anoPca: String(anoAtual),
                carregando: false,
                mensagemCarregamento: '',
                searchParams: null,
                listaPca: [],
                /** Sequencial do PCA exibido em resumo + tabela (pré-visualização). */
                pcaPrevisualizado: null,
                /** Sequenciais dos PCAs marcados para importação (pode haver vários). */
                pcaMarcadosImportacao: [],
                /** Cache de itens por sequencial: { [sequencial]: linha[] } */
                itensPorPca: {},
                resumoOrgao: null,
                itens: [],
                filtroItens: '',
                sortKey: 'numero',
                sortDir: 1,


                instituicao: {
                    nrCpfCnpj: null,
                    nmExibicao: null,
                },
            };
        },
        computed: {
            cnpjConsultaValido() {
                return pncpCnpjRaw(this.cnpjOrgao).length === 14;
            },
            carregandoBuscaInicial() {
                return this.carregando && String(this.mensagemCarregamento || '').startsWith('Buscando');
            },
            /** Carregamento do consolidado + páginas de itens (mensagem na área da tabela). */
            carregandoDetalhesPca() {
                return this.carregando && !this.carregandoBuscaInicial;
            },
            itensFiltrados() {
                const q = (this.filtroItens || '').trim().toLowerCase();
                if (!q) return this.itens;
                return this.itens.filter((r) => {
                    const blob = [
                        r.descricao,
                        r.subtitulo,
                        r.categoria,
                        r.classificacao,
                        r.grupoContratacao,
                        String(r.numero),
                    ].join(' ').toLowerCase();
                    return blob.includes(q);
                });
            },
            itensFiltradosOrdenados() {
                const list = [...this.itensFiltrados];
                const k = this.sortKey;
                const d = this.sortDir;
                const numericKeys = ['quantidade', 'numero', 'valorTotal', 'valorUnitario'];
                list.sort((a, b) => {
                    let va = a[k];
                    let vb = b[k];
                    if (numericKeys.includes(k)) {
                        va = Number(va);
                        vb = Number(vb);
                    } else {
                        va = String(va || '').toLowerCase();
                        vb = String(vb || '').toLowerCase();
                    }
                    if (va < vb) return -1 * d;
                    if (va > vb) return 1 * d;
                    return 0;
                });
                return list;
            },
            podeImportar() {
                return this.pcaMarcadosImportacao.length > 0;
            },
            textoBotaoImportar() {
                const n = this.pcaMarcadosImportacao.length;
                if (n === 0) return 'itens selecionados';
                if (n === 1) return '1 PCA selecionado';
                return `${n} PCAs selecionados`;
            },
            /** Quando há vários PCAs na lista e todos já estão marcados para importação. */
            todosPcasMarcadosParaImportacao() {
                if (!this.listaPca.length) return false;
                return this.listaPca.every((n) => this.pcaMarcadosImportacao.indexOf(n) >= 0);
            },
        },
        methods: {
            getDadosInstituicao() {
                let $this = this;
                axios.get(`${urlApi}/Instituicao/Get`)
                    .then(res => {
                        if (res.data.success) {
                            var instituicao = res.data.data;
                            $this.instituicao = {
                                nrCpfCnpj: instituicao.nrCpfCnpj,
                                nmExibicao: instituicao.nmExibicao,
                                urlImagem: instituicao.urlImagem,
                                urlImagemS3: instituicao.urlImagemS3,
                            };

                            $this.cnpjOrgao = formatCnpjAlfanumerico($this.instituicao.nrCpfCnpj);

                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    });
            },

            resetMapping() {
                this.searchParams = null;
                this.listaPca = [];
                this.pcaPrevisualizado = null;
                this.pcaMarcadosImportacao = [];
                this.itensPorPca = {};
                this.resumoOrgao = null;
                this.itens = [];
                this.filtroItens = '';
                this.carregando = false;
                this.mensagemCarregamento = '';
            },

            onCnpjInput(e) {
                const field = e.target;
                const selectionStart = field.selectionStart || 0;
                const rawCharCount = getCnpjRawCharCount(field.value.substring(0, selectionStart));
                const formatted = formatCnpjAlfanumerico(field.value);

                // Atualiza o DOM direto (padrão contato.js): se o valor reativo não mudar,
                // o Vue não re-renderiza e caracteres extras permaneceriam no input.
                field.value = formatted;
                this.cnpjOrgao = formatted;

                if (field === document.activeElement) {
                    const newPos = getCnpjCursorPosition(formatted, rawCharCount);
                    field.setSelectionRange(newPos, newPos);
                }
            },

            maskCnpj(value) {
                return formatCnpjAlfanumerico(value);
            },

            formatMoney(v) {
                const n = Number(v);
                if (Number.isNaN(n)) return '—';
                return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            },

            formatNumberPt(v) {
                return Number(v).toLocaleString('pt-BR');
            },

            formatDatePt(iso) {
                if (!iso) return '—';
                const d = new Date(iso);
                if (Number.isNaN(d.getTime())) return '—';
                return d.toLocaleDateString('pt-BR');
            },

            formatCnpjExibicao(cnpjValue) {
                const formatted = formatCnpjAlfanumerico(cnpjValue);
                return pncpCnpjRaw(formatted).length === 14 ? formatted : (cnpjValue || '');
            },

            mapConsolidadoParaResumo(cons) {
                return {
                    nome: cons.razaoSocial,
                    cnpj: this.formatCnpjExibicao(cons.cnpj),
                    localizacao: `${cons.municipio} - ${cons.uf}`,
                    anoPca: String(cons.anoPca),
                    numeroControle: cons.numeroControlePNCP,
                    totalItens: cons.quantidade,
                    valorTotal: this.formatMoney(cons.valorTotal),
                    metaLinha:
                        `Unidade: ${cons.nomeUnidade} (${cons.codigoUnidade}) | Publicado em: ${this.formatDatePt(cons.dataPublicacaoPncp)} | Atualizado em: ${this.formatDatePt(cons.dataAtualizacao)} | Fonte: ${cons.usuario || 'PNCP'}`,
                };
            },

            mapItemApiParaLinha(item, sequencial) {
                const seq = sequencial != null ? sequencial : item.sequencialPca;
                return {
                    id: `${seq}-${item.numeroItem}`,
                    sequencialPca: seq,
                    numero: item.numeroItem,
                    descricao: item.descricao,
                    subtitulo: item.pdmDescricao || item.codigoItem || '',
                    categoria: item.categoriaItemPcaNome,
                    categoriaItemPcaid: item.categoriaItemPcaid,
                    classificacao: item.classificacaoSuperiorNome,
                    grupoContratacao: item.grupoContratacaoNome,
                    quantidade: item.quantidade,
                    unidade: item.unidadeFornecimento,
                    valorUnitario: item.valorUnitario,
                    valorTotal: item.valorTotal,
                };
            },

            async consultar() {
                const cnpj = pncpCnpjRaw(this.cnpjOrgao);
                const ano = parseInt(String(this.anoPca || '').trim(), 10);
                if (cnpj.length !== 14) {
                    avisoErro('Informe um CNPJ válido (AA.AAA.AAA/AAAA-00).');
                    return;
                }
                if (Number.isNaN(ano) || ano < 2000 || ano > 2100) {
                    avisoErro('Informe um ano válido.');
                    return;
                }

                this.resumoOrgao = null;
                this.itens = [];
                this.listaPca = [];
                this.pcaPrevisualizado = null;
                this.pcaMarcadosImportacao = [];
                this.itensPorPca = {};
                this.searchParams = { cnpj, ano };

                this.carregando = true;
                this.mensagemCarregamento = 'Buscando planos do órgão...';

                try {
                    const qtd = await fetchPcaQuantidade(cnpj, ano);

                    if (qtd === 0) {
                        avisoToast('Este órgão não possui PCA para o ano selecionado.', 'info');
                        this.carregando = false;
                        this.mensagemCarregamento = '';
                        return;
                    }

                    this.listaPca = Array.from({ length: qtd }, (_, i) => i + 1);

                    if (qtd === 1) {
                        this.carregando = false;
                        this.mensagemCarregamento = '';
                        await this.previsualizarPca(1);
                        this.pcaMarcadosImportacao = [1];
                    } else {
                        this.carregando = false;
                        this.mensagemCarregamento = '';
                    }
                } catch (err) {
                    avisoErro(err && err.message ? err.message : 'Verifique o CNPJ e o ano informados.');
                    this.carregando = false;
                    this.mensagemCarregamento = '';
                    this.searchParams = null;
                    this.listaPca = [];
                }
            },

            isPcaMarcadoParaImport(sequencial) {
                return this.pcaMarcadosImportacao.indexOf(sequencial) >= 0;
            },

            setMarcaImportPca(sequencial, marcar) {
                let arr = this.pcaMarcadosImportacao.filter((x) => x !== sequencial);
                if (marcar) {
                    arr.push(sequencial);
                }
                arr = [...new Set(arr)].sort((a, b) => a - b);
                this.pcaMarcadosImportacao = arr;
            },

            selecionarTodosPcasParaImportacao() {
                this.pcaMarcadosImportacao = [...this.listaPca].sort((a, b) => a - b);
            },

            /**
             * @param {number} sequencial
             * @param {(msg: string) => void} [onProgress] — atualiza mensagem na área da tabela durante a busca
             */
            async obterDadosPca(sequencial, onProgress) {
                const { cnpj, ano } = this.searchParams;
                if (onProgress) onProgress('Carregando dados consolidados...');
                const cons = await fetchPcaConsolidado(cnpj, ano, sequencial);
                if (onProgress) onProgress(`Carregando ${cons.quantidade} itens...`);
                const apiItens = await fetchAllPcaItens(cnpj, ano, sequencial, cons.quantidade);
                const mapped = apiItens.map((item) => this.mapItemApiParaLinha(item, sequencial));
                return { cons, mapped };
            },

            /** Carrega consolidado + itens no cache sem atualizar a pré-visualização (ex.: durante importação). */
            async garantirItensEmCache(sequencial) {
                const cached = this.itensPorPca[sequencial];
                if (cached && cached.length) {
                    return cached;
                }
                const { mapped } = await this.obterDadosPca(sequencial, null);
                this.$set(this.itensPorPca, sequencial, mapped);
                return mapped;
            },

            async previsualizarPca(sequencial) {
                if (this.carregando || !this.searchParams) return;

                this.pcaPrevisualizado = sequencial;
                this.itens = [];
                this.carregando = true;
                this.mensagemCarregamento = 'Carregando dados consolidados...';

                try {
                    const { cons, mapped } = await this.obterDadosPca(sequencial, (msg) => {
                        this.mensagemCarregamento = msg;
                    });
                    this.$set(this.itensPorPca, sequencial, mapped);
                    this.resumoOrgao = this.mapConsolidadoParaResumo(cons);
                    this.itens = mapped;
                } catch (err) {
                    avisoErro(err && err.message ? err.message : 'Não foi possível carregar os dados deste PCA.');
                    this.resumoOrgao = null;
                    this.itens = [];
                    this.pcaPrevisualizado = null;
                } finally {
                    this.carregando = false;
                    this.mensagemCarregamento = '';
                }
            },

            alternarOrdenacao(key) {
                if (this.sortKey === key) {
                    this.sortDir *= -1;
                } else {
                    this.sortKey = key;
                    this.sortDir = 1;
                }
            },

            exportarCsv() {
                const nomeOrgao = (this.resumoOrgao && this.resumoOrgao.nome) ? this.resumoOrgao.nome.replace(/\s/g, '_') : 'pca';
                const cols = ['Nº', 'Descrição', 'Subtítulo', 'Categoria', 'Classificação', 'Grupo Contratação', 'Qtd', 'Unid.', 'Valor Unit.', 'Valor Total'];
                const rows = this.itensFiltradosOrdenados.map((r) => [
                    r.numero,
                    `"${String(r.descricao).replace(/"/g, '""')}"`,
                    `"${String(r.subtitulo || '').replace(/"/g, '""')}"`,
                    r.categoria,
                    r.classificacao,
                    r.grupoContratacao,
                    r.quantidade,
                    r.unidade,
                    this.formatMoney(r.valorUnitario),
                    this.formatMoney(r.valorTotal),
                ]);
                const csv = [cols.join(';'), ...rows.map((line) => line.join(';'))].join('\n');
                const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `pca_${nomeOrgao}_${Date.now()}.csv`;
                a.click();
                URL.revokeObjectURL(url);
            },

            async importarItensCgov() {
                if (!this.podeImportar || this.importando || !this.searchParams) return;
                const sequenciais = [...this.pcaMarcadosImportacao].sort((a, b) => a - b);
                const { cnpj, ano } = this.searchParams;
                const payload = {
                    nrCpfCnpj: cnpj,
                    nrAno: ano,
                    lstPcas: sequenciais.map((s) => String(s)),
                };

                this.importando = true;
                try {
                    const { data } = await axios.post(
                        `${urlApi}/RegistroNecessidade/PostImportacaoPNCP`,
                        payload,
                        { headers: { 'Content-Type': 'application/json' } }
                    );

                    if (data && data.success) {
                        avisoToast(data.msg || 'Importação PNCP enviada com sucesso.');
                        this.$emit('import-finished');
                        this.fecharModal(true);
                    } else {
                        avisoErro((data && data.msg) || 'Não foi possível iniciar a importação PNCP.');
                    }
                } catch (err) {
                    avisoErro(err);
                } finally {
                    this.importando = false;
                }
            },

            abrirModal(callbackDeRetorno) {
                this.retornoAoFechar = callbackDeRetorno || null;
                const modalEl = this.$refs.modalImportacaoPCA;
                const modalInstance = new window.bootstrap.Modal(modalEl);
                modalInstance.show();

                const onHidden = () => {
                    if (this.foiFechadaDeFormaTemporaria) {
                        this.foiFechadaDeFormaTemporaria = false;
                        return;
                    }

                    if (typeof this.retornoAoFechar === 'function') {
                        this.retornoAoFechar();
                        this.retornoAoFechar = null;
                    }

                    modalEl.removeEventListener('hidden.bs.modal', onHidden);
                };

                modalEl.addEventListener('hidden.bs.modal', onHidden);
            },

            fecharModal(dispararCallback = false) {
                const modal = window.bootstrap.Modal.getInstance(
                    this.$refs.modalImportacaoPCA
                );
                if (modal) modal.hide();

                this.resetMapping();

                if (dispararCallback && typeof this.retornoAoFechar === 'function') {
                    this.retornoAoFechar();
                    this.retornoAoFechar = null;
                }
            },
        },
        mounted() {
            this.getDadosInstituicao();
        }
    };
</script>

<style scoped>
    .modal-grande {
        width: 100% !important;
        max-width: 98vw !important;
        margin: auto;
        margin-top: 18px;
        padding: 0 12px;
    }

    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 5%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .btn-close-modern {
        border-radius: 50%;
        border: 2px solid rgba(148, 163, 184, 0.28);
        background: #ffffff;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        z-index: 10;
    }

        .btn-close-modern:hover {
            transform: scale(1.06);
            box-shadow: 0 14px 34px rgba(37, 99, 235, 0.18);
        }

    .btn-md {
        z-index: 1001;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 18px;
        padding: 32px 32px 26px;
        position: relative;
    }

        .modal-modern-header::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 32px;
            right: 32px;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
        }

    .header-icon {
        width: 60px;
        height: 60px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.16) 0%, rgba(14, 165, 233, 0.16) 100%);
        color: #2563eb;
        flex-shrink: 0;
    }

    .header-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

        .header-text h2 {
            margin: 0;
            font-size: 24px;
            font-weight: 700;
            color: #0f172a;
        }

        .header-text p {
            margin: 0;
            font-size: 14px;
            color: #475569;
            line-height: 1.5;
        }

    .modal-modern-body {
        padding: 24px 32px 28px;
        display: flex;
        flex-direction: column;
        gap: 0;
        max-height: min(72vh, 900px);
        overflow-y: auto;
    }

    .pca-layout {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .pca-loading-banner {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        padding: 14px 16px;
        border-radius: 10px;
        background: #f1f5f9;
        border: 1px solid #e2e8f0;
        font-size: 14px;
        font-weight: 500;
        color: #475569;
    }

    .pca-loading-spin {
        width: 22px;
        height: 22px;
        border: 3px solid #cbd5e1;
        border-top-color: #1d4ed8;
        border-radius: 50%;
        animation: pca-spin 0.75s linear infinite;
        flex-shrink: 0;
    }

    .pca-btn-spinner {
        width: 18px;
        height: 18px;
        border: 2px solid rgba(255, 255, 255, 0.35);
        border-top-color: #fff;
        border-radius: 50%;
        animation: pca-spin 0.7s linear infinite;
        display: inline-block;
    }

    @keyframes pca-spin {
        to {
            transform: rotate(360deg);
        }
    }

    .pca-card {
        background: #fff;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        padding: 20px 22px;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    }

    .pca-card-filter {
        padding-bottom: 18px;
    }

    .pca-filter-row {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 16px 20px;
    }

    .pca-field {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .pca-field-grow {
        flex: 1 1 220px;
        min-width: 200px;
    }

    .pca-field-ano {
        flex: 0 0 100px;
        width: 100px;
    }

    .pca-field-btn {
        flex: 0 0 auto;
    }

    .pca-label {
        font-size: 13px;
        font-weight: 600;
        color: #334155;
    }

    .pca-label-invisible {
        visibility: hidden;
        user-select: none;
    }

    .pca-input {
        width: 100%;
        height: 42px;
        padding: 0 14px;
        border: 1px solid #cbd5e1;
        border-radius: 8px;
        font-size: 14px;
        color: #0f172a;
        background: #fff;
        transition: border-color 0.15s ease, box-shadow 0.15s ease;
    }

        .pca-input:focus {
            outline: none;
            border-color: #1d4ed8;
            box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.15);
        }

    .pca-input-with-icon {
        position: relative;
    }

        .pca-input-with-icon .pca-input {
            padding-right: 42px;
        }

    .pca-input-suffix {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #94a3b8;
        display: flex;
        pointer-events: none;
    }

    .pca-btn-consultar {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        height: 42px;
        padding: 0 20px;
        border: none;
        border-radius: 8px;
        font-weight: 600;
        font-size: 14px;
        color: #fff;
        background: #1d4ed8;
        cursor: pointer;
        transition: background 0.15s ease, transform 0.12s ease;
        white-space: nowrap;
    }

        .pca-btn-consultar:hover:not(:disabled) {
            background: #1e40af;
        }

        .pca-btn-consultar:active:not(:disabled) {
            transform: scale(0.98);
        }

        .pca-btn-consultar:disabled {
            opacity: 0.65;
            cursor: not-allowed;
        }

    .pca-card-pca-list {
        padding-top: 16px;
        padding-bottom: 18px;
    }

    .pca-pca-list-head {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 14px;
    }

    .pca-doc-icon {
        color: #64748b;
        flex-shrink: 0;
    }

    .pca-pca-list-text {
        margin: 0;
        flex: 1 1 200px;
        min-width: 0;
        font-size: 14px;
        color: #475569;
    }

    .pca-btn-selecionar-todos-pca {
        flex-shrink: 0;
        white-space: nowrap;
    }

        .pca-btn-selecionar-todos-pca:disabled {
            opacity: 0.65;
            cursor: not-allowed;
        }

        .pca-pca-list-text strong {
            color: #0f172a;
            font-weight: 700;
        }

    .pca-pca-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .pca-chip-wrap {
        display: inline-flex;
        align-items: stretch;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        overflow: hidden;
        background: #fff;
    }

    .pca-chip-import {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        margin: 0;
        background: #f8fafc;
        border-right: 1px solid #e2e8f0;
        cursor: pointer;
        user-select: none;
    }

        .pca-chip-import input {
            width: 16px;
            height: 16px;
            cursor: pointer;
            accent-color: #1d4ed8;
        }

    .pca-chip-wrap .pca-chip {
        border: none;
        border-radius: 0;
    }

    .pca-chip {
        padding: 8px 14px;
        font-size: 13px;
        font-weight: 600;
        color: #0f172a;
        background: #fff;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        cursor: pointer;
        transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
    }

        .pca-chip:hover {
            border-color: #cbd5e1;
            background: #f8fafc;
        }

        .pca-chip.active {
            background: #1d4ed8;
            border-color: #1d4ed8;
            color: #fff;
        }

    .pca-card-resumo {
        padding: 0;
        overflow: hidden;
    }

    .pca-resumo-banner {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 16px 20px;
        background: #1d4ed8;
        color: #fff;
    }

    .pca-banner-icon {
        flex-shrink: 0;
        margin-top: 2px;
        opacity: 0.95;
    }

    .pca-banner-title {
        font-size: 14px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.02em;
        line-height: 1.35;
    }

    .pca-banner-sub {
        margin-top: 6px;
        font-size: 13px;
        opacity: 0.92;
    }

    .pca-metricas {
        display: grid;
        grid-template-columns: repeat(5, minmax(0, 1fr));
        gap: 0;
        border-top: 1px solid #e2e8f0;
        background: #fff;
    }

    .pca-metrica {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 6px;
        padding: 18px 10px;
        border-right: 1px solid #f1f5f9;
    }

        .pca-metrica:last-child {
            border-right: none;
        }

    .pca-metrica-ico {
        color: #94a3b8;
    }

    .pca-metrica-label {
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: #94a3b8;
    }

    .pca-metrica-valor {
        font-size: 14px;
        font-weight: 600;
        color: #0f172a;
        line-height: 1.3;
        word-break: break-word;
    }

    .pca-metrica-valor-sm {
        font-size: 12px;
    }

    .pca-valor-total {
        font-size: 15px;
        font-weight: 700;
        color: #10b981;
    }

    .pca-resumo-footer {
        padding: 10px 18px 12px;
        font-size: 12px;
        color: #94a3b8;
        border-top: 1px solid #f1f5f9;
        background: #fafafa;
    }

    .pca-card-tabela {
        padding: 0;
        overflow: hidden;
    }

    .pca-table-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 14px;
        min-height: 280px;
        padding: 32px 20px;
        font-size: 14px;
        font-weight: 500;
        color: #475569;
        background: #fafbfc;
    }

    .pca-toolbar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 16px;
        border-bottom: 1px solid #e2e8f0;
        background: #fff;
    }

    .pca-toolbar-search {
        display: flex;
        align-items: center;
        gap: 10px;
        flex: 1 1 200px;
        max-width: 360px;
        padding: 0 12px;
        height: 40px;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        background: #fff;
        color: #94a3b8;
    }

    .pca-toolbar-input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 14px;
        color: #0f172a;
        min-width: 0;
        background: transparent;
    }

        .pca-toolbar-input::placeholder {
            color: #94a3b8;
        }

    .pca-toolbar-right {
        display: flex;
        align-items: center;
        gap: 14px;
    }

    .pca-toolbar-count {
        font-size: 13px;
        color: #64748b;
        white-space: nowrap;
    }

    .pca-btn-csv {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        height: 38px;
        padding: 0 14px;
        font-size: 13px;
        font-weight: 600;
        color: #334155;
        background: #fff;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        cursor: pointer;
        transition: border-color 0.15s ease, background 0.15s ease;
    }

        .pca-btn-csv:hover {
            background: #f8fafc;
            border-color: #cbd5e1;
        }

    .pca-table-wrap {
        max-height: 320px;
        overflow: auto;
    }

    .pca-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
    }

        .pca-table thead th {
            position: sticky;
            top: 0;
            z-index: 1;
            background: #f8fafc;
            text-align: left;
            font-weight: 600;
            color: #475569;
            padding: 10px 12px;
            border-bottom: 1px solid #e2e8f0;
            white-space: nowrap;
        }

    .pca-th-sort {
        cursor: pointer;
        user-select: none;
    }

        .pca-th-sort:hover {
            color: #1d4ed8;
        }

    .pca-sort {
        font-size: 10px;
        color: #cbd5e1;
        margin-left: 4px;
    }

        .pca-sort.active {
            color: #1d4ed8;
        }

    .pca-th-num {
        text-align: right;
    }

        .pca-table tbody td {
            padding: 12px;
            border-bottom: 1px solid #f1f5f9;
            vertical-align: top;
            color: #334155;
        }

    .pca-td-desc {
        max-width: 280px;
    }

    .pca-desc-titulo {
        font-weight: 700;
        text-transform: uppercase;
        font-size: 12px;
        line-height: 1.35;
        color: #0f172a;
    }

    .pca-desc-sub {
        margin-top: 4px;
        font-size: 12px;
        color: #64748b;
        line-height: 1.35;
    }

    .pca-badge {
        display: inline-block;
        padding: 4px 10px;
        border-radius: 999px;
        font-size: 11px;
        font-weight: 700;
        text-transform: capitalize;
    }

    .pca-badge-material {
        background: #1d4ed8;
        color: #fff;
    }

    .pca-badge-servico {
        background: #e0f2fe;
        color: #0369a1;
    }

    .pca-td-num {
        text-align: right;
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
    }

    .modal-modern-footer {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        padding: 0 32px 32px;
        flex-wrap: wrap;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 22px;
        border-radius: 14px;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        border: none;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
        color: #ffffff;
    }

        .modern-btn:hover:not(:disabled) {
            transform: translateY(-2px);
        }

        .modern-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none;
            box-shadow: none;
        }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    }

    @media (max-width: 1100px) {
        .pca-metricas {
            grid-template-columns: repeat(2, 1fr);
        }

        .pca-metrica {
            border-right: none;
            border-bottom: 1px solid #f1f5f9;
        }
    }

    @media (max-width: 768px) {
        .modal-dialog.modal-grande {
            margin: 0;
            max-width: 100% !important;
        }

        .modal-modern-body {
            padding: 20px 18px;
            max-height: none;
        }

        .modal-modern-footer {
            padding: 0 18px 24px;
            justify-content: center;
        }

        .pca-metricas {
            grid-template-columns: 1fr;
        }

        .pca-toolbar {
            flex-direction: column;
            align-items: stretch;
        }

        .pca-toolbar-search {
            max-width: none;
        }

        .pca-toolbar-right {
            justify-content: space-between;
        }
    }

    @media (max-width: 576px) {
        .modal-modern-header,
        .modal-modern-body {
            padding: 22px 18px;
        }

        .modal-modern-footer {
            padding: 0 18px 22px;
        }
    }

    /* Dark mode */
    [data-bs-theme="dark"] .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111827 100%) !important;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.92) !important;
        border-color: rgba(148, 163, 184, 0.35) !important;
    }

        [data-bs-theme="dark"] .btn-close-modern svg {
            color: #e2e8f0;
        }

    [data-bs-theme="dark"] .btn-close-modern:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    }

    [data-bs-theme="dark"] .modal-modern-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
    }

    [data-bs-theme="dark"] .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.26) 0%, rgba(14, 165, 233, 0.26) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .header-text p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .pca-loading-banner {
        background: rgba(30, 41, 59, 0.85);
        border-color: rgba(148, 163, 184, 0.2);
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .pca-loading-spin {
        border-color: rgba(148, 163, 184, 0.35);
        border-top-color: #60a5fa;
    }

    [data-bs-theme="dark"] .pca-card {
        background: rgba(17, 24, 39, 0.92);
        border-color: rgba(148, 163, 184, 0.18);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    }

    [data-bs-theme="dark"] .pca-label {
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .pca-input {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.25);
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .pca-input:focus {
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
        }

        [data-bs-theme="dark"] .pca-input::placeholder {
            color: #64748b;
        }

    [data-bs-theme="dark"] .pca-input-suffix {
        color: #64748b;
    }

    [data-bs-theme="dark"] .pca-doc-icon {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .pca-pca-list-text {
        color: #94a3b8;
    }

        [data-bs-theme="dark"] .pca-pca-list-text strong {
            color: #f1f5f9;
        }

    [data-bs-theme="dark"] .pca-chip-wrap {
        background: rgba(15, 23, 42, 0.75);
        border-color: rgba(148, 163, 184, 0.22);
    }

    [data-bs-theme="dark"] .pca-chip-import {
        background: rgba(30, 41, 59, 0.75);
        border-right-color: rgba(148, 163, 184, 0.22);
    }

    [data-bs-theme="dark"] .pca-chip {
        background: rgba(15, 23, 42, 0.75);
        border-color: rgba(148, 163, 184, 0.22);
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .pca-chip:hover {
            background: rgba(30, 41, 59, 0.85);
            border-color: rgba(148, 163, 184, 0.35);
        }

        [data-bs-theme="dark"] .pca-chip.active {
            background: #2563eb;
            border-color: #2563eb;
            color: #fff;
        }

    [data-bs-theme="dark"] .pca-resumo-banner {
        background: linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%);
    }

    [data-bs-theme="dark"] .pca-metricas {
        background: rgba(17, 24, 39, 0.95);
        border-top-color: rgba(148, 163, 184, 0.18);
    }

    [data-bs-theme="dark"] .pca-metrica {
        border-right-color: rgba(148, 163, 184, 0.12);
    }

    [data-bs-theme="dark"] .pca-metrica-ico {
        color: #64748b;
    }

    [data-bs-theme="dark"] .pca-metrica-label {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .pca-metrica-valor {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .pca-valor-total {
        color: #34d399;
    }

    [data-bs-theme="dark"] .pca-resumo-footer {
        background: rgba(15, 23, 42, 0.65);
        border-top-color: rgba(148, 163, 184, 0.15);
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .pca-table-loading {
        background: rgba(15, 23, 42, 0.55);
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .pca-toolbar {
        background: rgba(17, 24, 39, 0.95);
        border-bottom-color: rgba(148, 163, 184, 0.18);
    }

    [data-bs-theme="dark"] .pca-toolbar-search {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.22);
        color: #64748b;
    }

    [data-bs-theme="dark"] .pca-toolbar-input {
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .pca-toolbar-input::placeholder {
            color: #64748b;
        }

    [data-bs-theme="dark"] .pca-toolbar-count {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .pca-btn-csv {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.22);
        color: #cbd5e1;
    }

        [data-bs-theme="dark"] .pca-btn-csv:hover {
            background: rgba(30, 41, 59, 0.9);
            border-color: rgba(148, 163, 184, 0.35);
        }

    [data-bs-theme="dark"] .pca-table thead th {
        background: #111827;
        color: #cbd5e1;
        border-bottom-color: rgba(148, 163, 184, 0.18);
    }

    [data-bs-theme="dark"] .pca-th-sort:hover {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .pca-sort {
        color: #475569;
    }

        [data-bs-theme="dark"] .pca-sort.active {
            color: #60a5fa;
        }

    [data-bs-theme="dark"] .pca-table tbody td {
        border-bottom-color: rgba(148, 163, 184, 0.12);
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .pca-desc-titulo {
        color: #f1f5f9;
    }

    [data-bs-theme="dark"] .pca-desc-sub {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .pca-badge-servico {
        background: rgba(14, 165, 233, 0.22);
        color: #7dd3fc;
    }

    [data-bs-theme="dark"] .modern-btn-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
    }
</style>
